import { Stack } from '@mui/material';
import { useIsMobile } from '@client/hooks/dom.hooks';
import type { StackProps } from '@mui/material';

interface ResponsiveStackProps {
  readonly desktopSpacing?: number;
  readonly mobileSpacing?: number;
}

export const ResponsiveStack: React.FC<ResponsiveStackProps & StackProps> = ({
  children, spacing, desktopSpacing, mobileSpacing, ...restProps
}) => {
  const isMobile = useIsMobile();

  let finalSpacing = spacing;

  if (mobileSpacing && isMobile) {
    finalSpacing = mobileSpacing;
  } else if (desktopSpacing && !isMobile) {
    finalSpacing = desktopSpacing;
  }

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      spacing={finalSpacing}
      {...restProps}
    >
      {children}
    </Stack>
  );
};
